import React from "react";

// Convert <u> and <b> tags to inline styles
function renderQuestionWithUnderline(question) {
  return {
    __html: question
      .replace(/<b><u>(.*?)<\/u><\/b>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
      .replace(/<b><u>(.*?)<\/b><\/u>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
      .replace(/<u>(.*?)<\/u>/g, '<span style="text-decoration:underline; font-weight:bold;">$1</span>')
  };
}

const N2MojiGoi1 = ({
  questions,
  selectedAnswers,
  showResult,
  handleAnswerChange,
}) => {
  if (!questions) return null;

  return (
    <div>
      <div style={{ fontSize: "1.2rem", marginBottom: "0.5rem", fontWeight: 'bold' }}>
        問題１ ___のことばの読み方として最もよいものを、1・2・3・4 から一つ えらびなさい。
      </div>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {questions.map((item, idx) => (
          <li
            key={item.id}
            style={{
              marginBottom: '2.5rem',
              width: '100%',
              background: '#f8faff',
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(25,118,210,0.07)',
              padding: '1.2rem'
            }}
          >
            <div style={{ marginBottom: '1rem', fontSize: '1.2rem', fontWeight: 500 }}>
              <span style={{ marginRight: 12 }}>{idx + 1}.</span>
              <span dangerouslySetInnerHTML={renderQuestionWithUnderline(item.question)} />
            </div>

            {item.answers && item.answers.length === 4 && (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '1rem',
                  justifyContent: 'center'
                }}
              >
                {item.answers.map((ans, ansIdx) => {
                  const isSelected = selectedAnswers[item.id] === ansIdx;
                  let color;
                  if (showResult) {
                    if (ansIdx === item.correct) color = 'green';
                    else if (isSelected) color = 'red';
                  }

                  return (
                    <label
                      key={ansIdx}
                      style={{
                        flex: '1 1 180px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0.8rem 1rem',
                        borderRadius: '6px',
                        border: '1px solid #e0e0e0',
                        background: '#fff',
                        cursor: showResult ? 'default' : 'pointer',
                        fontSize: '1.1rem',
                        fontWeight: isSelected ? 700 : 500,
                        textDecoration: isSelected ? 'underline' : 'none',
                        color: color,
                        transition: 'all 0.2s ease',
                        wordBreak: 'break-word',
                        boxSizing: 'border-box'
                      }}
                    >
                      <input
                        type="radio"
                        name={`question-${item.id}`}
                        value={ansIdx}
                        checked={isSelected}
                        onChange={() => handleAnswerChange(item.id, ansIdx)}
                        disabled={showResult}
                        style={{
                          marginRight: 12,
                          accentColor: "#1976d2",
                          width: 20,
                          height: 20
                        }}
                      />
                      {ans}
                      {showResult && ansIdx === item.correct && (
                        <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'green' }}>✓</span>
                      )}
                      {showResult && isSelected && ansIdx !== item.correct && (
                        <span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '1.2rem', color: 'red' }}>✗</span>
                      )}
                    </label>
                  );
                })}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default N2MojiGoi1;
